import { createTermTagManager } from '../../utils/createTermTagManager';

export const hasExtinguishingSystemTagManager = createTermTagManager({
  jsonQueryKey: 'has_extinguishing_system',
  label: 'Есть система пожаротушения',
  id: 'hasExtinguishingSystem',
});
